import { useCallback, useEffect, useContext, useState } from 'react';
import { CookieContext } from '../../context/CookieProvider';

export default function useCookie(cookieName: string) {
  const { getCookie, setCookie } = useContext(CookieContext);
  const [cv, setCv] = useState<string>('');
  const [isInitialized, setIsInitialized] = useState(false);

  // useEffect to prevent updating in same step as render
  useEffect(() => {
    setCv(getCookie(cookieName));
    if (!isInitialized) {
      setIsInitialized(true);
    }
  }, [cookieName, getCookie]);

  const setCookieValue = useCallback(
    (value: any) => {
      if (isInitialized) {
        setCookie(cookieName, value);
      }
    },
    [cookieName, setCookie, isInitialized]
  );

  return { cookieValue: cv, setCookie: setCookieValue };
}

export const FF_OVERRIDE_KEY = 'ht_ffor';
